export default "__VITE_ASSET__iCFMN2UH__"